import { styled } from '@sds-system/system';
import { getAllStyledProps, processNestedCSS } from '@sds-system/utils';
import { selectFontStyle, selectGhostSizeStyle, selectSizeStyle } from '../Select/Select.styled';
import type { SystemSelectTriggerStyledProps } from './SystemSelect.types';

export const StyledSystemSelectTrigger = styled('select', {
  componentName: 'SystemSelect',
  slot: 'trigger',
})<SystemSelectTriggerStyledProps>(
  ({ theme, triggerSize = 'M', variant = 'outline' }) => {
    return {
      outline: 'none',
      textAlign: 'left',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
      ...(variant === 'ghost' ? selectGhostSizeStyle(triggerSize) : selectSizeStyle(triggerSize)),
      ...(triggerSize && selectFontStyle(theme, triggerSize, variant)),
    };
  },
  ({ theme, isError }) => ({
    variants: [
      {
        props: { variant: 'outline' },
        style: {
          backgroundColor: theme.palette.bg.primary,
          border: '1px solid',
          borderColor: isError ? theme.palette.border.error : theme.palette.border.secondary,

          borderRadius: theme.borderRadius[8],
          '&:disabled': processNestedCSS(
            {
              border: '1px solid',
              borderColor: theme.palette.border.disabled,
              backgroundColor: theme.palette.bg.disabledLight,
              color: theme.palette.text.disabled,
            },
            theme,
          ),
        },
      },
      {
        props: { variant: 'ghost' },
        style: {
          color: theme.palette.text.secondary,
          backgroundColor: 'transparent',
          border: 'none',
          '&:disabled': processNestedCSS(
            {
              color: theme.palette.icon.disabled,
            },
            theme,
          ),
        },
      },
    ],
  }),
  getAllStyledProps,
);
